if (!customElements.get('th-sticky-atc')) {
  class ThStickyAtc extends HTMLElement {
    constructor() {
      super();

      this.RECHARGE_SELECT_SELECTOR = "[data-th-recharge-select]";
      this.RECHARGE_RADIO_INPUT_SELECTOR = ".rc-radio__input";

      this.combinedListingSelect = this.querySelector("[data-combined-listing-select]");
      this.addToCartButton = this.querySelector("#AddToCartSticky");
      this.addToCartPrice = this.querySelector("[data-atc-price]");
      this.buyOnceOption = this.querySelector('[data-sticky-buy-once]');
      this.buyOncePrice = this.buyOnceOption ? this.buyOnceOption.getAttribute("data-sticky-buy-once") : null;
  
    }

    connectedCallback() {
      this.RECHARGE_SELECT = this.querySelector(this.RECHARGE_SELECT_SELECTOR);

      this.attachListeners();

      document.addEventListener("section-content::changed", () => {
        this.toggleStickyATC();
      });
    }

    attachListeners() {
      window.addEventListener("scroll", (event) => {
        this.toggleStickyATC();
      });
      if (this.RECHARGE_SELECT) {
        window.addEventListener("th:recharge-ready", (event) => {
          this.handleRechargeChange(event);
        });
        window.addEventListener("th:recharge-change", (event) => {
          this.handleRechargeChange(event);
        });
        this.RECHARGE_SELECT.addEventListener("change", () => {
          this.handleSelectChange();
        });
      }

      if (this.addToCartButton) {
        this.addToCartButton.addEventListener("click", (event) => {
          this.handleAddToCartClick(event);
        });
      }
      if (this.combinedListingSelect) {
        this.combinedListingSelect.addEventListener("change", () => {
          this.handleATCPrice();
        });
      }
    }


    handleATCPrice() {
      if (this.combinedListingSelect.value === this.buyOnceOption.value) {
        if (this.buyOncePrice && this.addToCartPrice) {
          this.addToCartPrice.innerText = this.buyOncePrice;
        }
      } 
    };



    handleAddToCartClick(event) {
      if (this.combinedListingSelect.value === this.buyOnceOption.value) {
        event.preventDefault();
        const variantId = this.buyOnceOption.getAttribute("data-variant-id");
        if (variantId) {
          this.addToCart(variantId);
        }
      } 
    }
    
    addToCart(variantId) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        }),
      })
      .then(response => response.json())
      .catch(error => {
        console.error("Error adding to cart:", error);
      });
    }


    toggleStickyATC() {
      const form = document.getElementById(`product-form-${this.dataset.section}`)
      const footer = document.getElementById('footer');
      if (!this.elementIsVisibleInViewport(form) && !this.elementIsVisibleInViewport(footer, true)) {
        this.classList.add('sticky--visible');
        this.moveAccessiblyIcon(true);
        this.moveMessengerIcon(true);
      } else {
        this.classList.remove('sticky--visible');
        this.moveAccessiblyIcon(false);
        this.moveMessengerIcon(false);
      }
    }

    elementIsVisibleInViewport(el, partiallyVisible = false) {
      const { top } = el.getBoundingClientRect();
      const { innerHeight } = window;
      return partiallyVisible ? top <= (innerHeight / 2) : top >= 76;
    };

    moveAccessiblyIcon(visible) {
      const icon = document.getElementById('accessiblyAppWidgetButton');
      if (icon && visible) {
        icon.classList.add('th-sticky-atc-open');
      } else if (icon && !visible) {
        icon.classList.remove('th-sticky-atc-open');
      }
    }

    moveMessengerIcon(visible) {
      const icons = document.querySelectorAll('#gorgias-chat-container iframe');
      icons.forEach(icon => {

        if (visible) {
          icon.classList.add('th-sticky-atc-open__messenger');
        } else {
          icon.classList.remove('th-sticky-atc-open__messenger');
        }
      });
    }


    // Below is legacy code used for Recharge. Not deleting yet in case they change their minds, but can likely be deleted in future - 2025-02-25

    handleRechargeChange(event) {
      if (!event.detail) {return}
      if (event.detail.value === 'subscription') {
        this.RECHARGE_SELECT.value = 'Monthly';
      } else if (event.detail.value === 'onetime') {
        this.RECHARGE_SELECT.value = 'One-Time';
      }
    }

    handleSelectChange() {
      if (this.RECHARGE_SELECT.value === 'Monthly') {
        document.querySelectorAll(this.RECHARGE_RADIO_INPUT_SELECTOR).forEach((input) => {
          if (input.value === 'subscription') {
            input.parentElement.click();
          }
        });
      } else if (this.RECHARGE_SELECT.value === 'One-Time') {
        document.querySelectorAll(this.RECHARGE_RADIO_INPUT_SELECTOR).forEach((input) => {
          if (input.value === 'onetime') {
            input.parentElement.click();
          }
        });
      }
    }



  }

  customElements.define('th-sticky-atc', ThStickyAtc);
}
